import { memo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import GovernancaLayout from '../layouts/GovernancaLayout';
import { QueryClientContextProvider } from '../context/QueryClientContext';
import ModuloObrigacaoAppLayout from '../modules/modulo-obrigacoes/src/layouts/ModuloObrigacaoAppLayout';
import ModuloObrigacoesAppRoute from '../modules/modulo-obrigacoes/src/routes/moduloObrigacoes.router';
import { KeycloakContextProvider } from '../context/KeycloakContext';
import { AppConfigModuloObrigacoes } from '../modules/modulo-obrigacoes/configs/config';
import CadastrarUsuario from '../shared/pages/CadastrarUsuario';
import { GovernancaContextProvider } from '../context/GovernancaContext';
import HeadManager from '../shared/components/headManager';
import PaginaNaoEncontrada from '../pages/NotFound';

export default function AppRoutes() {
	const ModuloObrigacoesElement = memo(() => {
		const { keycloakConfig } = AppConfigModuloObrigacoes;

		return (
			<KeycloakContextProvider clientId={keycloakConfig.clientId}>
				<QueryClientContextProvider>
					<GovernancaContextProvider>
						<ModuloObrigacaoAppLayout />
					</GovernancaContextProvider>
				</QueryClientContextProvider>
			</KeycloakContextProvider>
		);
	});
	ModuloObrigacoesElement.displayName = 'ModuloObrigacoesElement';

	return (
		<>
			<HeadManager />
			<Routes>
				<Route path='/' element={<GovernancaLayout />}>
					<Route index element={<Navigate to='/obrigacoes/listagem' />} />

					<Route path='cadastrar-usuario' index element={<CadastrarUsuario />} />
				</Route>

				<Route path='/obrigacoes/*' element={<ModuloObrigacoesElement />}>
					<Route path='*' element={<ModuloObrigacoesAppRoute />} />
				</Route>

				<Route path='*' element={<PaginaNaoEncontrada />} />
			</Routes>
		</>
	);
}
